const BookLoader = () => {
  const commonStyle = {
    width: "66px",
    height: "24px",
    backgroundColor: "#e2e2e2",
    borderRadius: "6px",
  };

  const titleStyle = {
    ...commonStyle,
    width: "200px",
    height: "12px",
    marginTop: "10px",
  };

  const authorStyle = {
    ...titleStyle,
    width: "100px",
    marginTop: "20px",
  };

  const ratingStyle = {
    ...commonStyle,
    width: "16px",
    height: "12px",
  };

  const priceStyle = {
    ...authorStyle,
    width: "80px",
  };

  return (
    <div className="book-card">
      <img
        src="https://via.placeholder.com/170x240"
        className="h-[240px] w-[170px]"
        alt="placeholder"
        style={{ backgroundColor: "#e2e2e2" }}
      />
      <div className="flex-1 h-full pr-2 pt-2 flex flex-col">
        <div className="flex items-center justify-between">
          <div style={commonStyle}></div>
          <div className="text-gray-500 flex space-x-2">
            <p style={{ ...commonStyle, width: "30px" }}></p>
            <p style={{ ...commonStyle, width: "30px" }}></p>
          </div>
        </div>

        <div className="space-y-2 mt-4 h-full">
          <p style={titleStyle}></p>
          <p style={authorStyle}></p>
          <div className="flex space-y-2">
            <p
              style={{
                ...ratingStyle,
                marginTop: "8px",
              }}
            ></p>
            <p
              style={{
                ...ratingStyle,
                marginInline: "6px",
              }}
            ></p>
            <p style={ratingStyle}></p>
          </div>
          <p style={priceStyle}></p>
        </div>
      </div>
    </div>
  );
};

export default BookLoader;
